var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLucideEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3779_33047",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V28H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0V28H41V0H39Z",
    fill: "#E2E2E2",
    mask: "url(#path-1-inside-1_3779_33047)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.585 6.91797H13.7516C13.3096 6.91797 12.8857 7.09356 12.5731 7.40612C12.2606 7.71868 12.085 8.14261 12.085 8.58464V20.2513C12.085 20.6933 12.2606 21.1173 12.5731 21.4298C12.8857 21.7424 13.3096 21.918 13.7516 21.918H25.4183C25.8603 21.918 26.2842 21.7424 26.5968 21.4298C26.9094 21.1173 27.085 20.6933 27.085 20.2513V14.418",
    stroke: "#4D94FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8972 6.6037C25.2287 6.27218 25.6784 6.08594 26.1472 6.08594C26.6161 6.08594 27.0657 6.27218 27.3972 6.6037C27.7287 6.93522 27.915 7.38486 27.915 7.8537C27.915 8.32255 27.7287 8.77218 27.3972 9.1037L19.8864 16.6154C19.6885 16.8131 19.4441 16.9578 19.1755 17.0362L16.7814 17.7362C16.7097 17.7571 16.6337 17.7584 16.5613 17.7398C16.4889 17.7213 16.4229 17.6836 16.3701 17.6308C16.3173 17.578 16.2796 17.512 16.2611 17.4396C16.2425 17.3673 16.2438 17.2912 16.2647 17.2195L16.9647 14.8254C17.0435 14.5571 17.1885 14.3129 17.3864 14.1154L24.8972 6.6037Z",
    stroke: "#4D94FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideEdit);
export default __webpack_public_path__ + "static/media/lucide_edit.a795f438afd3aa0c069c026954ca7a61.svg";
export { ForwardRef as ReactComponent };